import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReadingProgress from 'react-reading-progress'

import './custom-reading-progress.css';

class CustomReadingProgress extends Component {
  render() {
    return (
      <div className='custom-reading-progress'> 
        <ReadingProgress targetEl={this.props.targetEl} />
      </div>
    );
  }
}

CustomReadingProgress.propTypes = {
  targetEl: PropTypes.string
}

export default CustomReadingProgress;
        